import React from "react";
import { useTranslation } from "react-i18next";
import { useExternalUrls } from "../../contexts/ExternalUrlsContext";
import "./Footer.css";
import { Link } from "react-router-dom";

const CustomFooter = () => {
  const { t } = useTranslation();
  const { kgh } = useExternalUrls();

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="footer-brand d-flex justify-center align-middle">
          <img src={require("../../assets/white_corridor10_logo.png")} alt="Corridor 10" />
        </div>
        <div className="footer-column">
          <h4 className="mb-3">{t("footer:contact-us", "Contact Us")}</h4>
          <a href="mailto:corridor@mail.com">corridor@mail.com</a>
          <p className="mt-3"><a href="tel:+38977223223">+38977223223</a></p>
          <p className="mt-3">ul. Partizanska 55</p>
          <p>1000 Skopje</p>
        </div>
        <div className="footer-column">
          <h4 className="mb-3">{t("landing:footer.legal", "Legal")}</h4>
          <Link to="/" className="mt-3">{t("landing:footer.terms", "Terms & Conditions")}</Link>
          <Link to="/privacy-policy" className="mt-3">{t("landing:footer.privacy", "Privacy Policy")}</Link>
        </div>
      </div>
      <div className="footer-copy">
       {t("landing:footer.copy", {
  defaultValue: `Copyright © ${new Date().getFullYear()} All rights reserved by`,
  year: new Date().getFullYear() // જો JSON માં {{year}} વાપરવું હોય તો
})}{" "}
        <a href={kgh} target="_blank" rel="noopener noreferrer">
          {t("landing:footer.copy-link", "iVote")}
        </a>
      </div>
    </footer>
  );
};

export default CustomFooter;
